import DateInput from './container'

export default DateInput
